import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";

import InputBar from "../../components/TripStatistics/InputBar";
import TripStatisticsData from "../../components/TripStatistics/TripStatisticsData";
import * as TripStatisticsActions from "../../store/actions/TripStatistics";
import { Heading } from "../../constants/assets/containers";
import { isMobile } from "../../utils";

const TripStatistics = (props) => {
  const handleSubmit = (data) => {
    // removing keys with `undefined` or empty values
    Object.keys(data).forEach(
      (key) => (data[key] === undefined || data[key] === "") && delete data[key]
    );

    if (Object.keys(data).length > 0) {
      props.getTripStatistics(data);
    }
  };

  useEffect(() => {
    props.resetState({ state: "tripStatisticsData" });
  }, []);

  return (
    <TripStatisticsContainer>
      <div className="inner-container flex flex-start mb-20 justify-between">
        <Heading>Trip Statistics</Heading>
        <InputBar handleSubmit={handleSubmit} />
      </div>
      <TripStatisticsData data={props.tripStatisticsData} />
    </TripStatisticsContainer>
  );
};

const TripStatisticsContainer = styled.section`
  height: calc(100vh - 220px);
  .inner-container {
    flex-direction: ${isMobile() ? "column" : "row"};
    margin-bottom: ${isMobile() ? "40px" : "20px"};
    .actionBar {
      flex-direction: ${isMobile() ? "column" : "row"};
      align-items: ${isMobile() ? "flex-start" : "flex-start"};
      margin-left: ${isMobile() ? "unset" : "auto"};
      margin-top: ${isMobile() ? "10px" : "unset"};
    }
  }
`;

const mapStateToProps = (state) => {
  const { TripStatistics } = state;
  return {
    tripStatisticsData: TripStatistics.tripStatisticsData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTripStatistics: bindActionCreators(
      TripStatisticsActions.getTripStatistics,
      dispatch
    ),
    resetState: bindActionCreators(TripStatisticsActions.resetState, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TripStatistics);
